VP = window.VP || {};

(function( $, slick ) {
	VP.factsModule = {
		init: function () {
			var _this = this;
			this.generateCarousel();
		},

		centerArrow: function() {
			var _this = this;
			var slideHeight = $('.vp-module__facts .slick-track').height() + 60;
			var pagContainer = $('.vp-module__facts .vp-slide__pagination');

			if (VP.breakpoint.currentBreakpoint !== 'small') {
				pagContainer.css('height', slideHeight);
			} else {
				pagContainer.css('height', '');
			}
		},

		generateCarousel: function() {
			var _this = this;

			$.each($('.vp-module__facts'), function(index, val) {

				$module = $(this);

				var $content = $('.vp-facts__content-slides', $module),
					$contentSlider = $('.vp-facts__slides', $content),
					$mainSlider = $('.vp-facts__main-image-slides', $module),
					$previous = $('.vp-slide__previous', $mainSlider),
					$next = $('.vp-slide__next', $mainSlider),
					$pagination = $('.vp-slide__pagination', $mainSlider),
					$paginationText = $('span', $pagination),
					$mainSliderSlides = $('.vp-facts__slides', $mainSlider),
					$previewSlider = $('.vp-facts__preview-image-slides', $module),
					$previewSliderSlides = $('.vp-facts__slides', $previewSlider);

				$mainSliderSlides.slick({
					arrows: false,
					draggable: false,
					slidesToScroll: 1,
					slidesToShow: 1,
					waitForAnimate: true,
					infinite: false,
					swipe: true,
					responsive: [{
						breakpoint: 699,
						settings: {
							centerMode: true
						}
				    }],
				}).on('swipe', function(evt, slick, dir) {
					if (dir === 'right') {
						$previewSliderSlides.slick('slickPrev');
						$contentSlider.slick('slickPrev');
					} else {
						$previewSliderSlides.slick('slickNext');
						$contentSlider.slick('slickNext');
					}
				});

				$previewSliderSlides.slick({
					arrows: false,
					draggable: false,
					slidesToScroll: 1,
					slidesToShow: 1,
					waitForAnimate: true,
					infinite: false,
					swipe: false,
				});

				$contentSlider.slick({
					asNavFor: $mainSliderSlides.add($previewSliderSlides),
					arrows: true,
					draggable: false,
					fade: true,
					slidesToScroll: 1,
					slidesToShow: 1,
								waitForAnimate: true,
								infinite: false,
					prevArrow: $previous,
					nextArrow: $next,
				})
				.on('beforeChange', function(event, slick, currentSlide, nextSlide){
					$paginationText.text( nextSlide + 1);
				});
			});
		},
	};
})(jQuery);
